import { render, staticRenderFns } from "./Count.vue?vue&type=template&id=3079c820"
import script from "./Count.vue?vue&type=script&lang=js"
export * from "./Count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports